import './internal.login-system.less'
import AbstractLoginSystem from '../abstract-login-system';
import AbstractLoginSystemController from '../abstract-login-system-controller';
import type {IHttpService, IOnInit} from 'angular';
import type {RegistrationOptions} from '../../../registration-options';
import type UserService from '../../../../../features/user/user.service';
import type RegistrationService from '../../../registration.service';
import {ngAsync} from '../../../../utils/ng-@decorators';
import type MainLoginFormService from '../../../main-login-form-service';
import type {Auth} from 'typings/portaro.be.types';
import {getErrorMessage, responseToData} from '../../../../utils/data-service-utils';

export class InternalLoginSystemComponentController extends AbstractLoginSystemController implements IOnInit {

    public static readonly INTERNAL_AUTH_ROUTE = '/api/auth/internal';

    public registrationOptions: RegistrationOptions;

    public credentials = {
        username: '',
        password: ''
    };

    /*@ngInject*/
    constructor(private userService: UserService,
                private mainLoginFormService: MainLoginFormService,
                private $http: IHttpService,
                private CONTEXT_PATH: string,
                private registrationService: RegistrationService) {
        super();
    }

    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    public async $onInit() {
        this.registrationOptions = await this.registrationService.getRegistrationOptions();
    }

    @ngAsync()
    public async submitLoginForm(): Promise<void> {
        this.mainLoginFormService.clearError();
        this.mainLoginFormService.startProcessing();

        try {
            const currentAuthentication = await this.sendRequest();
            return this.loginController.modalLoginFormController.closeFormOnSuccess(currentAuthentication);
        } catch (e) {
            this.mainLoginFormService.setError(getErrorMessage(e));
            /* ignore login error, error message was already displayed by login form */
        } finally {
            this.mainLoginFormService.endProcessing();
        }
    }

    private async sendRequest(): Promise<Auth> {
        try {
            const httpResponse = await this.$http.post<Auth>(InternalLoginSystemComponentController.INTERNAL_AUTH_ROUTE, this.credentials);
            return responseToData(httpResponse);
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    public async showRegistration() {
        this.loginController.modalLoginFormController.closeFormOnCancel();
        return this.registrationService.showRegistrationOptions();
    }

    @ngAsync()
    public async showForgottenCredentials() {
        this.loginController.modalLoginFormController.closeFormOnCancel();
        return this.userService.changePasswordMail();
    }
}


export default class InternalLoginSystemComponent extends AbstractLoginSystem {
    public static componentName = 'internal.loginSystem';

    public templateUrl = require('./internal.login-system.tpl.ftl');

    public controller = InternalLoginSystemComponentController;
}
